import { postRequest, getRequest,getRequestWithNoCredential, putRequest } from "@/utils/request";
// import axios from "axios";
// import { getUacBaseUrl } from "@/utils/tools";
// const baseURLAuth = getUacBaseUrl();

// const serviceAuth = axios.create({
//   baseURL: baseURLAuth,
//   timeout: 5000,
//   withCredentials: true
// });
// postKeyValueRequest,  uploadFileRequest, putRequest, deleteRequest,

// 获取部门列表
// const departUrl = ''
// export function departList(data) {
//   return getRequest(departUrl, data );
// }

// 员工实时搜索
const searchByAccountUrl = "/employee/search_by_account";
export function searchByAccount(data) {
  return getRequest(searchByAccountUrl, data);
}
// 员工列表
const memberUrl = "/employee/list";
export function memberList(data) {
  return getRequest(memberUrl, data);
}

// 账号详情
const memberDetailUrl = "/employee/detail";
export function memberDetail(id) {
  return getRequest(`${memberDetailUrl}/${id}`);
}

// 清除次数
const clearNumberUrl = "/auth/error/times";
export function clearNumber(params) {
  return postRequest(`${clearNumberUrl}`, params);
}
// 发送邮箱
const sendemailaccountUrl = "/employee/sendemailaccount";
export function sendemailaccount(id) {
  return getRequest(`${sendemailaccountUrl}/${id}`);
}
// 发送邮箱202205
const sendExmailByIdAccounttUrl = "/employee/sendexmail";
export function sendExmailByIdAccount(id,params) {
  return postRequest(`${sendExmailByIdAccounttUrl}/${id}`, params);
}
export function sendExmailByIdAccountTwo(url) {
  return getRequestWithNoCredential(url);
}
// 发送账号
const sendEmailUrl = "/employee/sendemail";
export function sendEmail(id) {
  return getRequest(`${sendEmailUrl}/${id}`);
}

//获取路由权限列表
// const getRouteUrl = "/mock.json";
// export function getRouteList(language) {
//   if (language === "zh_cn") {
//     //调试的而已
//     return axios.get(getRouteUrl, {
//       headers: { lang: language }
//     });
//   } else {
//     return axios.get("/mockEN.json", {
//       headers: { lang: language }
//     });
//   }
// }

const getRouteUrl = "/auth/user/rights";
export function getRouteList(language) {
  return getRequest(getRouteUrl, {
    headers: { lang: language }
  });
}

//刷新权限
const freshUrl = "/auth/user/rights/flush";
export function freshAuth() {
  return getRequest(freshUrl);
}

// 重置密码
const resetPwdUrl = "/employee/reset_password";
export function resetPwd(data) {
  return putRequest(resetPwdUrl, data);
}

// 新增前确认通行证信息
const checkInfoUrl = "/employee/check_info";
export function checkInfo(data) {
  return postRequest(checkInfoUrl, data);
}

// 新增通行证
const createUrl = "/employee/create";
export function create(data) {
  return postRequest(createUrl, data);
}

//登录
const loginUrl = "/auth/login";
export function login(data) {
  return postRequest(loginUrl, data);
}

//登出
const logoutUrl = "/auth/logout";
export function logout() {
  return getRequest(logoutUrl);
}

//获取用户信息
const userInfoUrl = "/auth/user";
export function userInfo() {
  return getRequest(userInfoUrl);
}

//获取用户权限
const userAuthUrl = "/auth/user/rights";
export function userAuth() {
  return getRequest(userAuthUrl);
}

// 编辑通行证
const editUrl = "/employee/update";
export function editInfo(data) {
  return postRequest(editUrl, data);
}

// 获取部门树形结构
const departmentUrl = "/meta/departments";
export function getDepart(data) {
  return getRequest(departmentUrl, data);
}

// 获取岗位
const jobsUrl = "/meta/jobs";
export function getJobs(data) {
  return getRequest(jobsUrl, data);
}

// 获取谷歌验证码
const googleKeyUrl = "/employee/generate_ggkey";
export function getKey(data) {
  return getRequest(googleKeyUrl, data);
}

// 账号启用
const activationUrl = "/employee/activation";
export function activation(id) {
  return putRequest(`${activationUrl}/${id}`);
}

// 账号禁用
const dimissionUrl = "/employee/dimission";
export function dimission(id) {
  return putRequest(`${dimissionUrl}/${id}`);
}


// 账号禁用
const checkAccountUrl = "/employee/check_account_enable";
export function checkAccount(data) {
  return postRequest(checkAccountUrl, data);
}

// 获取随机密码

const getRandomUrl = "/employee/generate_password"
export function generatePsw(params) {
  return getRequest(getRandomUrl, params);
}

// 获取职位列表
const jobListUrl = "/job/list"
export function getJoblist(params) {
  return getRequest(jobListUrl, params);
}

// 职位新增编辑 id  0:新增 1:编辑
const jobSaveUrl = "job/save";
export function jobSave(data) {
  return postRequest(jobSaveUrl, data);
}

// 职位删除 
const jobDelUrl = "job/del";
export function jobDel(data) {
  return postRequest(jobDelUrl, data);
}

// 添加部门负责人
const modifyDutyAccountUrl = "department/modify_duty_account";
export function modifyDutyAccount(data) {
  return postRequest(modifyDutyAccountUrl, data);
}
// 添加部门 name supervisor_id
const depAddUrl = "department/create";
export function depAdd(data) {
  return postRequest(depAddUrl, data);
}

// 删除部门 id
const depDelUrl = "department/delete";
export function depDel(data) {
  return postRequest(depDelUrl, data);
}

//  判断是否可删除
const deletableUrl = "department/deletable";
export function deletable(data) {
  return getRequest(deletableUrl, data);
}

// 更改部门
const depModifyUrl = "department/modify";
export function depModify(data) {
  return postRequest(depModifyUrl, data);
}
